import React, { FC } from 'react';

import {
  Box,
  Link,
  Stack,
  Image,
  Center,
  HStack,
  Text,
} from '@chakra-ui/react';
import jira_token from 'images/jira_token.png';
import map from 'lodash/map';

import { HelpCount } from 'components/DataDisplay/Utils/HelpCount';
import { steps } from 'containers/Setup/Integrations/Components/IntegrationsWizard/Jira/Components/Help/steps';

export const JIRAHelp: FC = () => {
  return (
    <Stack px={4} spacing={6} pt={4}>
      {map(steps, (each, index) => (
        <Stack spacing={1} key={`${index}-jira`}>
          <HStack align={'start'}>
            <HelpCount count={index + 1}></HelpCount>
            <Box>{each.description}</Box>
          </HStack>
          <Box pt={4} pb={4} pl={8}>
            <Center>
              <Image src={each.image} alt={each.alt} boxSize={each?.boxSize} />
            </Center>
            {each.image2 && (
              <Center>
                <Image
                  src={each.image2}
                  alt={each.alt2}
                  pt={4}
                />
              </Center>
            )}
          </Box>
        </Stack>
      ))}
    </Stack>
  );
};

export const JIRAHelp1 = () => {
  return (
    <Stack px={4} spacing={6} pt={4} h="full">
      <HStack align={'start'}>
        <HelpCount count={1} />
        <Box>
          Log in to{' '}
          <Link
            color="primary"
            href="https://id.atlassian.com/manage/api-tokens"
            isExternal
          >
            Atlassian JIRA
          </Link>
          .
        </Box>
      </HStack>
      <HStack align={'start'}>
        <HelpCount count={2} />
        <Text>
          From the dialog that appears, enter a short, memorable, and easy to
          remember <Text as="b">Label</Text> for your token and click{' '}
          <Text as="b">Create</Text>.
        </Text>
      </HStack>
      <HStack align={'start'}>
        <HelpCount count={3} />
        <Box>
          Make sure you copy and save your new API token. You won’t be able to
          see this token again.
          <Center>
            <Box
              border="1px solid"
              borderRadius={0}
              borderColor="gray.200"
              my={4}
            >
              <Image src={jira_token} h={56} fit="cover" />
            </Box>
          </Center>
        </Box>
      </HStack>
    </Stack>
  );
};
